import { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';

import { FHSimpleTable } from '../../../base';
import { sessionHistoryDataTransformer } from '../utils';
import { history } from '../../../../helpers';
import { sessionHistoryColumns, getHistoryTableOptions } from '../table-configs/';

import type { HistoricalDocuments } from '../../../../pages/constants';
import type { BTSessionStatus } from '../../../../constants';
import type { ISessionMinified } from '../../../../utils/types';

interface ISessionHistoryTableData {
  id?: string;
  client: string;
  status: BTSessionStatus;
  session_id: string;
  date: string;
  time: string;
  duration: string;
}

interface ISessionHistoryTableProps {
  data: ISessionMinified[];
  documentType: HistoricalDocuments;
}

function SessionHistoryTable({ data = [], documentType }: ISessionHistoryTableProps) {
  const tableOptions = useMemo(() => {
    return {
      ...getHistoryTableOptions(documentType),
      onRowClick: (args: any) => {
        history.navigate(`/sessions/${args[0]}`);
      },
    };
  }, [documentType]);

  const [historyTableData, setHistoryTableData] = useState<ISessionHistoryTableData[]>([]);

  useEffect(() => {
    const transformedTableData = sessionHistoryDataTransformer(data);
    setHistoryTableData(transformedTableData);
  }, [data]);

  return (
    <Box data-testid="historicalSessionsTable">
      <FHSimpleTable
        data={historyTableData}
        columnDefinitions={sessionHistoryColumns}
        columnOptions={tableOptions}
      />
    </Box>
  );
}

export default SessionHistoryTable;
